<template>
  <main>
    <b-tabs>
      <b-tab title="Informasi Barang">
        <b-card-actions :no-actions="true">
          <validation-observer ref="form">
            <b-row class="mb-2">
              <b-col md="5" sm="12">
                <b-form-group label="Nama Barang" label-for="">
                  <validation-provider
                    #default="{ errors }"
                    name="nama"
                    :rules="{ required: true }"
                  >
                    <b-form-input
                      v-model="form.nama"
                      placeholder="Ex: Kaos Polos"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3" sm="12" v-if="!isAdminGudang">
                <b-form-group label="Harga Dasar" label-for="">
                  <validation-provider
                    #default="{ errors }"
                    name="harga_dasar"
                    :rules="{ required: true }"
                  >
                  <b-input-group
                          prepend="Rp."
                          class="input-group-merge"
                        >
                    <b-form-input
                      v-model="form.harga_dasar"
                      @keyup="doFormatRupiah()"
                      placeholder="Harga Dasar"
                    />
                  </b-input-group>
                            <!-- <cleave
                              id="number"
                              v-model="form.harga_dasar"
                              class="form-control"
                              :raw="false"
                              :options="options2.number"
                              placeholder="10,000"
                            /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4" sm="6">
                <b-form-group label="Jenis Barang">
                  <validation-provider
                    #default="{ errors }"
                    name="jenis"
                    :rules="{ required: true }"
                  >
                    <b-form-select
                      v-model="form.jenis"
                      :options="options"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-2">
              <b-col></b-col>
              <b-col sm="12" md="10">
                <div class="d-flex justify-content-center">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Varian</th>
                        <th>Kode</th>
                        <th style="width: 3%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in form.variants" :key="i">
                        <td>
                          <b-form-input
                            placeholder="Ex: Ukuran XL"
                            v-model="item.varian"
                          />
                        </td>
                        <td>
                          <b-form-input placeholder="Ex: 23213" v-model="item.kode" />
                        </td>
                        <td>
                          <section v-if="i == 0 && !$route.params.id">
                            <b-button
                              @click.prevent="
                                form.variants.push({ variant: null, kode: null })
                              "
                              variant="primary"
                              size="sm"
                            >
                              <feather-icon icon="PlusIcon" />
                            </b-button>
                          </section>
                          <section v-else-if="i > 0 && !$route.params.id">
                            <b-button
                              @click.prevent="form.variants.splice(i, 1)"
                              variant="flat-danger"
                              size="sm"
                            >
                              <feather-icon icon="XIcon" />
                            </b-button>
                          </section>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
              <b-col></b-col>
            </b-row>
            <b-row>
              <b-col sm="10" md="4">
                <b-form-group label="Kategori">
                  <validation-provider
                    #default="{ errors }"
                    name="kategori"
                    :rules="{ required: true }"
                  >
                    <v-select
                      v-model="form.id_kategori"
                      :options="kategoriOptions"
                      :reduce="(option) => option.value"
                      label="text"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col sm="10" md="4">
                <b-form-group label="Satuan Terkecil">
                  <validation-provider
                    #default="{ errors }"
                    name="satuan"
                    :rules="{ required: true }"
                  >
                    <v-select
                      v-model="form.id_satuan"
                      :options="satuanOptions"
                      :reduce="(option) => option.value"
                      label="text"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          :required="!form.id_satuan"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-end">
              <b-button @click.prevent="submit" variant="primary">
                {{ label }}
              </b-button>
            </div>
          </validation-observer>
        </b-card-actions>
      </b-tab>
      <!-- <b-tab v-if="canManagePrice" title="Pengaturan Harga"> -->
      <b-tab title="Pengaturan Harga">
        <b-card>
          <b-alert v-if="isTipeKonsumenEmpty" variant="danger" show class="p-1">
            <div class="alert-body d-flex align-items-center">
                <div class="mr-1"><svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="currentColor"  class="icon icon-tabler icons-tabler-filled icon-tabler-alert-square"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-6.99 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" /></svg></div>
                <div>Untuk mengatur harga, harap input data tipe konsumen terlebih dahulu</div>
            </div>
          </b-alert>
          <b-table
            striped
            hover
            bordered
            :fields="[
              { key: 'no', label: 'No' },
              { key: 'nama', label: 'Jenis Harga' },
              { key: 'harga', label: 'Harga' },
            ]"
            :items="priceList"
            class="mb-2"
          >
            <template #cell(no)="{ index }">
              {{ index + 1 }}
            </template>
            <template #cell(harga)="{ item, index }">
                <b-form-input
                  v-model="item.harga"
                  @keyup="doFormatHarga({index, item})"
                  placeholder="Harga Dasar"
                />
            </template>
          </b-table>
          <div class="d-flex justify-content-end">
            <b-button variant="primary" @click.prevent="saveHarga">Simpan</b-button>
          </div>
        </b-card>
      </b-tab>
      <b-tab title="Konversi Satuan">
        <b-card>
          <b-row>
            <b-col md="2" sm="4" class="my-1">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-tambah
                variant="primary"
              >
                <!-- v-if="allowCreate()" -->
                <feather-icon icon="PlusIcon" class="mr-50" />
                Tambah
              </b-button>
              <!-- v-if="allowCreate() || allowUpdate()" -->
              <b-modal
                v-model="showModal"
                id="modal-tambah"
                cancel-variant="secondary"
                ok-title="Tambah"
                cancel-title="Batal"
                centered
                title="Form Tambah"
              >
                <b-form>
                  <!-- <b-form-group>
              <label for="no">Nomor Urutan</label>
              <b-form-input v-model="form2.no" id="gudang" placeholder="Nomor" type="number" />
            </b-form-group> -->
                  <b-form-group>
                    <label for="satuan">Pilih Satuan yang akan di konversikan</label>
                    <b-form-select
                      v-model="form2.id_satuan"
                      :options="id_satuan"
                      label="satuan"
                    />
                  </b-form-group>
                  <b-form-group>
                    <label for="nilai">Nilai</label>
                    
                    <b-input-group
                          prepend=""
                          class="input-group-merge"
                        >
                    <b-form-input
                      type="number"
                      v-model="form2.nilai"
                      placeholder="Harga Dasar"
                    />
                  </b-input-group>
                  </b-form-group>
                  <!-- <b-form-group>
              <label for="teritory">ID Barang</label>
              <b-form-input v-model="form2.id_barang" id="gudang" placeholder="Barang" type="number" />
            </b-form-group> -->
                </b-form>

                <template #modal-footer>
                  <section class="d-flex justify-content-end align-items-center">
                    <b-button
                      size="sm"
                      class="mr-1"
                      variant="success"
                      @click="saveKonversi"
                    >
                      Simpan
                    </b-button>
                    <b-button size="sm" class="mr-1" variant="primary" @click="resetForm">
                      Reset
                    </b-button>
                    <b-button size="sm" variant="danger" @click="showModal = false">
                      Keluar
                    </b-button>
                  </section>
                </template>
              </b-modal>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-table
                id="table2"
                striped
                small
                hover
                responsive
                :items="items"
                :fields="fields2"
              >
                <template #cell(id_barang)="data">
                  {{ getBarangName(data.item) }}
                </template>
                <template #cell(nilai)="{ item }">
                  {{ formatRupiah(item.nilai) }}
                </template>

                <template #cell(no)="{ index }">
                  {{ index + 1 }}
                </template>

                <template #cell(actions)="row">
                  <b-button
                    v-b-tooltip.hover.right="'Ubah'"
                    size="sm"
                    @click="edit(row.item)"
                    class="mr-1"
                    variant="outline-info"
                  >
                    <feather-icon icon="EditIcon" /> </b-button
                  ><b-button
                    v-b-tooltip.hover.right="'Hapus'"
                    size="sm"
                    @click="remove(row.item)"
                    class=""
                    variant="outline-danger"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
    </b-tabs>
  </main>
</template>
<script>
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BInputGroup,
  VBTooltip,
  BDropdown,
  BAlert,
  BDropdownItem,
  BAvatar,
  BBadge,
  BModal,
  BPagination,
  BInputGroupPrepend,
  BInputGroupAppend,
  BForm,
  BFormCheckbox,
  BTabs,
  BTab,
  BCard,
  BTable,
  BContainer,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BFormFile,
  BFormTextarea,
} from "bootstrap-vue";
import { getSubject } from "../../../libs/acl/utils";
import vSelect from "vue-select";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  components: {
    BInputGroup,
    Cleave,
    BTabs,
    BTab,
    BTable,
    BCard,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BCardActions,
    BContainer,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BFormFile,
    BFormTextarea,
    VBTooltip,
    BDropdown,
    BAlert,
    BDropdownItem,
    BAvatar,
    BBadge,
    BModal,
    BPagination,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormCheckbox,
    BForm,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    tipeKonsumen: [],
    label: "Simpan",
    konsumenTypes: [],
    selected: null,
    priceList: [],
    options2: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
    file: null,
    form: {
      nama: null,
      jenis: null,
      harga_dasar: 0,
      id_kategori: null,
      id_satuan: null,
      variants: [
        {
          kode: null,
          varian: null,
        },
      ],
    },
    canManagePrice: false,
    options: [
      // jenis options
      {
        value: 1,
        text: "Rokok",
      },
      {
        value: 2,
        text: "Non-Rokok",
      },
    ],
    selectedSatuan: null,
    selectedKategori: null,
    kategoriOptions: [],
    satuanOptions: [],
    showModalEdit: false,
    showModal: false,
    id: null,
    form2: {
      nilai: 0,
      id_satuan: null,
    },
    id_barang: [],
    id_satuan: [],
    perPage: 5,
    pageOptions: [3, 5, 10],
    totalRows: 1,
    currentPage: 1,
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    filter: null,
    filterOn: [],
    infoModal: {
      id: "info-modal",
      title: "",
      content: "",
    },
    fields2: [
      {
        key: "no",
        label: "No",
      },
      { key: "satuan.satuan", label: "dari satuan" },
      { key: "nilai", label: "Jumlah" },
      { key: "id_barang", label: "Satuan Terkecil" },
      { key: "actions", label: "Actions" },
    ],
    items: [],
    status: [
      {
        1: "Current",
        2: "Professional",
        3: "Rejected",
        4: "Resigned",
        5: "Applied",
      },
      {
        1: "light-primary",
        2: "light-success",
        3: "light-danger",
        4: "light-warning",
        5: "light-info",
      },
    ],
  }),

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    isTipeKonsumenEmpty() {
      return this.tipeKonsumen.length < 1
    }
  },
  methods: {
    doFormatHarga({index, item}) {
      this.priceList[index].harga = this.formatRupiah( this.priceList[index].harga )
      const prices = Object.assign([], this.priceList)
      this.priceList = []
      this.priceList = prices
    },
    doFormatRupiah() {
      this.form.harga_dasar = this.formatRupiah(this.form.harga_dasar)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async saveHarga() {
      const thereEmptyHarga = this.priceList.some((price) => this.unFormatRupiah(price.harga) < 1);
      if (thereEmptyHarga) {
        this.displayError({
          message: "Harga tidak boleh 0",
        });
        return false;
      }
      const payloads = [];
      this.priceList.map((price) => {
        let payload = {
          barang_id: price.barang_id,
          tipe_konsumen_id: price.id,
          harga: this.unFormatRupiah(price.harga),
        };
        if (price.harga_id) {
          payload.id = price.harga_id;
        }

        payloads.push(payload);
      });

      try {
        await this.$store.dispatch("harga-barang/save", payloads);
        this.displaySuccess({
          message: "Harga berhasil disimpan",
        });
      } catch (e) {
        this.displayError(e);
        return false;
      }
    },
    submit() {
      this.$refs.form.validate().then(async (success) => {
        if (success) {
          // validation for varian
          const thereEmptyVarian = this.form.variants.filter(
            (item) => item.varian == null || item.kode == null
          );

          if (thereEmptyVarian.length > 0) {
            this.displayError({
              message: "Harap isi varian dan kode yang kosong",
            });
            return false;
          }
          let payload = [];
          this.form.variants.map((item) => {
            let barangName = `${this.form.nama} - ${item.varian}`;
            let obj = {
              nama: barangName,
              kode: item.kode,
              varian: item.varian,
              id_kategori: this.form.id_kategori,
              id_satuan: this.form.id_satuan,
              jenis: this.form.jenis,
              harga_dasar: this.unFormatRupiah(this.form.harga_dasar),
            };
            if (this.$route.params.id) {
              obj.id = this.$route.params.id;
            }
            payload.push(obj);
          });
          try {
          this.label = "Loading...";
          const ajuan = await this.$store.dispatch("barang/save", payload)
              this.label = "Simpan";
              const message = this.$route.params.id
                ? "Barang berhasil diperbaharui"
                : "Barang berhasli ditambahkan";
              this.displaySuccess({
                message,
              });
              setTimeout(() => this.$router.push(`/barang/edit/${ajuan.id}`),1000 );
              
              
              const action = this.$route.params.id ? "update" : "create";
              
              this.checkPermission(action);
              this.getDataKonversi();
              this.getDatabarang();
              this.getStatus();
              // setTimeout(() => this.$router.push("/barang"), 1000);
            }
            catch(e) {
              this.label = "Simpan";
              this.displayError(e);
              return false;
            };
        }
      });
    },
    async getDataKonversi() {
      this.$store
        .dispatch("konversi/getData", { id_barang: this.$route.params.id })
        .then(() => {
          this.items = this.$store.state.konversi.datas;
          this.totalRows = this.items.length;
        })
        .catch((e) => console.error(e));
    },
    getDatabarang() {
      this.$store
        .dispatch("barang/getData", {})
        .then(() => {
          let ter = JSON.parse(JSON.stringify(this.$store.state.barang.datas));
          ter.map((item) => {
            item.value = item.id;
            item.text = item.nama + " - " + item.satuan.satuan;
          });
          this.id_barang = ter;
        })
        .catch((e) => console.error(e));
    },
    getBarangName(data) {
      let find = this.id_barang.find((item) => item.id == data.id_barang);
      return find ? find.satuan.satuan : "-";
    },
    async getSatuan() {
      let satuan = await this.$store.dispatch("satuan/getData");
      satuan = JSON.parse(JSON.stringify(satuan));
      let newSatuan = [];
      satuan.map((item) => {
        newSatuan.push({
          text: item.satuan,
          value: item.id,
        });
      });
      this.id_satuan = newSatuan;
      this.satuanOptions = newSatuan;
    },
    async getKategori() {
      let kategori = await this.$store.dispatch("kategori/getData");
      kategori = JSON.parse(JSON.stringify(kategori));
      let newKategori = [];
      kategori.map((item) => {
        newKategori.push({
          text: item.kategori,
          value: item.id,
        });
      });

      this.kategoriOptions = newKategori;
    },
    checkPermission(action) {
      const subject = getSubject(this.$route);

      if (!this.$can(action, subject)) {
        this.$router.push("/not-authorized");
      }
    },
    async getStatus() {
      const currentMenu = await this.currentMenu(this.$route.meta.parent);

      // get status for check current user can manage harga
      const listStatus = await this.$store.dispatch("statusrole/getData", {
        menu_id: currentMenu.id,
        level_id: this.user.level.id,
      });
      const canManagePrice = listStatus.find((status) => status.data_status == 1);
      this.canManagePrice = canManagePrice && this.$route.params.id ? true : false;
    },
    async getTypeKonsumen() {
      this.priceList = []
      const tipeKonsumen = await this.$store.dispatch("tipekonsumen/getData");
      this.tipeKonsumen = tipeKonsumen;
      tipeKonsumen.map(async (tipe) => {
        tipe.harga = 0;
        tipe.harga_id = null;
        tipe.barang_id = this.$route.params.id;
        const harga = await this.$store.dispatch("harga-barang/getData", {
          where: {
            barang_id: this.$route.params.id,
            tipe_konsumen_id: tipe.id,
          },
        });

        if (harga && harga.length > 0) {
          tipe.harga_id = harga[0].id;
          tipe.harga = this.formatRupiah(harga[0].harga);
        }
      });

      this.priceList = tipeKonsumen;
    },
    resetForm() {
      this.form2 = {
        id_barang: this.$route.params.id,
        nilai: 0,
        id_satuan: 0,
      };
    },
    saveKonversi() {
      if (this.form2.nilai == null || this.form2.nilai == "") {
        this.displayError(e);
        return false;
      }
      if (this.id) {
        this.form2.id = this.id;
      }
      const payload = this.form2;
      this.$store
        .dispatch("konversi/save", [payload])
        .then(() => {
          if (this.activeAction == "tambah") {
            this.id = null;
          }
          this.getDataKonversi();
          this.displaySuccess({
            message: "Konversi harga berhasil disimpan!",
          });
          this.resetForm();
          this.showModal = false;
          this.showModalEdit = false;
        })
        .catch((e) => {
              //   this.pesanGagalHapus();
              this.displayError(e);
              return false;
            });
      // this.pesanGagalSimpan()
    },
    edit(item) {
      let { satuan, barang } = item;
      this.id = item.id;
      this.form2 = item;
      this.form2.nilai = item.nilai;
      if (satuan) this.form2.id_satuan = satuan.id;
      if (barang) this.form2.id_barang = barang.id;
      this.showModal = true;
    },
    remove(item) {
      this.$swal({
        title: "Anda yakin?",
        text: `Data konversi harga ini akan dihapus`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          item.fungsi = 1; // soft delete
          this.$store
            .dispatch("konversi/save", [item])
            .then(() => {
              this.getDataKonversi();
              this.displaySuccess({
                message: "Konversi harga berhasil dihapus!",
              });
            })
            .catch((e) => {
              //   this.pesanGagalHapus();
              this.displayError(e);
              return false;
            });
        }
      });
    },
  },
  async mounted() {
    this.getDataKonversi();
    this.getDatabarang();
    // this.getStatus();
  },
  async created() {
    const action = this.$route.params.id ? "update" : "create";

    this.checkPermission(action);

    await this.getTypeKonsumen()

    this.getKategori();

    this.getSatuan();

    // this.getStatus();

    if (this.$route.params.id) {
      let barang = this.$store.getters["barang/getBarang"](this.$route.params.id);
      if (!barang) {
        barang = await this.$store.dispatch("barang/getDataById", this.$route.params.id);
      }
      // let ter = JSON.parse(JSON.stringify(barang));
      //     ter.map((item) => {
      //         item.value = item.id;
      //         item.text = item.nama + ' - ' + item.satuan.satuan;
      //     });
      this.form2 = {
        id_barang: barang.id,
      };
      this.form = {
        nama: barang.nama,
        jenis: barang.jenis,
        id_kategori: barang.kategori ? barang.kategori.id : null,
        id_satuan: barang.satuan ? barang.satuan.id : null,
        harga_dasar: barang.harga_dasar,
        variants: [
          {
            kode: barang.kode,
            varian: barang.varian,
          },
        ],
      };
    }
  },
};
</script>
